import { clientFetch } from '~/lib/.client/fetch';
import type { DuplicateIntegrationsPostBody, DuplicateIntegrationsPostResponse } from '~/routes/api.project.duplicate';

export async function duplicateIntegrations(fromProjectId: string, toProjectId: string) {
  const response = await clientFetch('/api/project/duplicate', {
    method: 'POST',
    body: JSON.stringify({
      fromProjectId,
      toProjectId,
    } satisfies DuplicateIntegrationsPostBody),
  });

  const result = await response.json<DuplicateIntegrationsPostResponse>();

  if (result && result.success) {
    return;
  }

  throw new Error(result?.error ?? 'An unknown error occurred.');
}
